import {Recco} from '.';

export enum ReccoType {
  DITTO = 'DITTO',
  COMMENT = 'COMMENT',
  SHARE = 'SHARE',
}

export class TrendingRecco extends Recco {
  degree?: string;
  type: ReccoType;
  constructor(json: any) {
    super(json);
    this.type = json.type;
    this.degree = json.degree;
  }
}
